/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Cancellation_TitleInputs */

const en_agb_cancellation_title = /** @type {(inputs: Agb_Cancellation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Cancellation`)
};

const de_agb_cancellation_title = /** @type {(inputs: Agb_Cancellation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Kuendigung`)
};

const fr_agb_cancellation_title = /** @type {(inputs: Agb_Cancellation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Résiliation`)
};

const es_agb_cancellation_title = /** @type {(inputs: Agb_Cancellation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Cancelación`)
};

const it_agb_cancellation_title = /** @type {(inputs: Agb_Cancellation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Cancellazione`)
};

const nl_agb_cancellation_title = /** @type {(inputs: Agb_Cancellation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Opzegging`)
};

const pl_agb_cancellation_title = /** @type {(inputs: Agb_Cancellation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Anulowanie`)
};

const fi_agb_cancellation_title = /** @type {(inputs: Agb_Cancellation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Peruutus`)
};

const da_agb_cancellation_title = /** @type {(inputs: Agb_Cancellation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Opsigelse`)
};

const sv_agb_cancellation_title = /** @type {(inputs: Agb_Cancellation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Avbokning`)
};

/**
* | output |
* | --- |
* | "10. Cancellation" |
*
* @param {Agb_Cancellation_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_cancellation_title = /** @type {((inputs?: Agb_Cancellation_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Cancellation_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_cancellation_title(inputs)
	if (locale === "fr") return fr_agb_cancellation_title(inputs)
	if (locale === "es") return es_agb_cancellation_title(inputs)
	if (locale === "it") return it_agb_cancellation_title(inputs)
	if (locale === "nl") return nl_agb_cancellation_title(inputs)
	if (locale === "pl") return pl_agb_cancellation_title(inputs)
	if (locale === "fi") return fi_agb_cancellation_title(inputs)
	if (locale === "da") return da_agb_cancellation_title(inputs)
	if (locale === "sv") return sv_agb_cancellation_title(inputs)
	return en_agb_cancellation_title(inputs)
});